module.exports = __webpack_public_path__ + "04311d15f3c837286802d7fa9a846f8c.glb";